export const BidayuhTraditionalCeremonies = [

  {
    
    img_src: "https://www.benarnews.org/malay/galeri-foto/my-ss-gawai-160607-06072016162606.html/160607-my-gawai-06-620.jpg",
    alt:'gawai-rumah',
    name: "Gawai Rumah",
    description: "Gawai Rumah is a ceremony performed by a new tenant before staying at a new house. The purpose of this ceremony is to get blessing and  at the same time to inform about their moving into the new place.",
  },
  
  {  
    img_src: "https://66.media.tumblr.com/de639de7e9c2cf5d139415d244c6ac4a/e45a3fa89d0c741a-d2/s1280x1920/75988bd7865d28f32ff6e6199bd7e77d94edc90c.png",
    alt: 'niligar-pilin',
    name: "Niligar Piin",
    description: "Niligar Piin is a ceremony conducted to ask for blessings from the gods. Based on the Bidayuh people's beliefs, the gods will show their blessings by showing up in the form of a fish.",

  },
  
  {
    img_src: "https://66.media.tumblr.com/8b82cfdcb2a7d2982886a8be0d7f917b/e45a3fa89d0c741a-08/s1280x1920/b8bb827bc18092f15b40477d82de13d1bedb890e.png",
    alt: 'upacara-manang',
    name: "Upacara Manang",
    description: "Upaca Manang is held to cure a disease. During the ceremony, the Bidayuh community will re-engage in the process of curing. The ceremony is usually held during the day.",
  },
  
  {
    img_src:"https://66.media.tumblr.com/fa0e3faf88b858ef2bbc5e94e3d1a820/tumblr_pxnohakeHl1yvw4bpo5_500.jpg",
    alt: 'merun-kiresah',
    name: "Upacara Merun Kiresah",
    description:"The Upacara Meren Kiresah is just like the Iban's Ngiling Bidai. It marks the end of the Gawai celebration. The shutters indicate the work has ended. The Bidayuh community will be waiting for hours until noon to hit the gong 12 times. After the gong has been beaten, the mat will be rolled in the middle of the crowd.",
  },
  
  {
    img_src:"https://66.media.tumblr.com/a5423359f47eec72dae1b3642744d342/e45a3fa89d0c741a-54/s250x400/c3702dadbf3a2613eb7a831e9152e18333b8631a.png",
    alt: 'mukak-gawai',
    name: "Upacara Mukak Gawai",
    description: "The Mukak Gawai ceremony indicates that the workshop will commence. The ceremony is a whole-day event whereby each zone needs to prepare food and offerings. During the ceremony, dances are performed and processions are done.",
  },
  
  {
    img_src: "https://66.media.tumblr.com/42d054e05f4c4a11e84994ac41285c58/tumblr_pxnohakeHl1yvw4bpo2_250.jpg",
    alt: 'upacara-nguguoh',
    name: "Upacara Nguguoh",
    description:"Upacara Nguguoh is a ritual that adores the spirits of harvest made before the Gawai (Gawea) celebration. The ritual ceremony was held to thank the spirits for good harvest and to ask for a better harvest in the coming seasons. In this ritual ceremony, food will be provided in abundance, in offering to the spirits.",
  },
  
  {
    img_src:"https://66.media.tumblr.com/3130eaed4c40b43624f4fcf8636bb8a1/tumblr_pxnohakeHl1yvw4bpo3_250.jpg",
    alt: 'upacara-nyebang',
    name: "Upacara Nyebang",
    description:" Upacara Nyebang is a great ceremony of welcoming heroes. It is one of the traditions preserved by Bidayuh sub ethnic Bidayuh Gumbang. Other Bidayuh sub-ethnic groups such as Bidayuh Bukar-Sadong, Bidayuh Jagoi-Sigai have their own rituals that may not be the same as those practiced by Bidayuh Gumbang. Normally, Nyebang is held for 2 days and 1 night. It is like a mass party for the Bidayuh Gumbang community.",
  },
  
  ];